import { render, staticRenderFns } from "./inputer.vue?vue&type=template&id=60148f0d"
import script from "./inputer.vue?vue&type=script&lang=js"
export * from "./inputer.vue?vue&type=script&lang=js"
import style0 from "./inputer.vue?vue&type=style&index=0&id=60148f0d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports